import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzTooltipWebComponent } from '../../gzTooltip';
import { FontSizes, FontWeights } from '../../../types/common/types';

export class GzLabeledContentWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/properties
  @property({ type: String, attribute: true, reflect: true })
  label = '';

  @property({ type: String, attribute: true, reflect: true })
  labelFontSize = FontSizes.PARAGRAPH_12;

  @property({ type: String, attribute: true, reflect: true })
  labelFontWeight = FontWeights.NORMAL;

  @property({ type: Boolean, attribute: true, reflect: true })
  stacked = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  hasColon = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  hasFormLabelWidth = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  clampLine = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  hasEllipsis = true;

  @property({ type: Boolean, attribute: true, reflect: true })
  hasTooltip = true;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div
        class="labeled-content ${this.stacked ? 'stacked' : ''} ${this.hasFormLabelWidth ? 'label-mw-250' : ''}"
        part="container"
      >
        <div class="content-label" part="label" @mouseleave="${this.hideEllipsisTooltip}">
          <gz-text fontSize="${this.labelFontSize}" fontWeight="${this.labelFontWeight}" lineHeight="1.2">
            <gz-tooltip tooltiptext="${this.hasTooltip ? this.label : ''}" ?isellipsis="${this.hasEllipsis}">
              <span>${this.label}${this.hasColon ? ':' : ''}</span>
            </gz-tooltip>
          </gz-text>
        </div>
        <div class="content-value" part="content"><slot></slot></div>
      </div>
    `;
  }

  hideEllipsisTooltip(event: MouseEvent) {
    const item = event.target as Element;
    const tooltip = item.querySelector('gz-tooltip') as GzTooltipWebComponent;
    tooltip.hideTooltip();
  }
}
